// Placeholder RestoMag lockup. Replace with the official SVG asset when available;
// the co-brand spec (PRD §7) requires the RestoMag mark to always be present.
export function RestoMagWordmark({ className }: { className?: string }) {
  return (
    <span className={className}>
      <span className="text-base font-extrabold tracking-tight text-neutral-900">
        Resto<span className="text-accent">Mag</span>
      </span>
    </span>
  );
}
